// src/redux/Slice/HolidayPlannerSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  holidayEvents: [], // Renamed from events to match pattern
  languages: [], // Renamed from languages_dropdown_list
  linguists: [],
  filters: {
    language: '',
    showAbsentOnly: false,
    showPresentOnly: false,
    startDate: '',
    endDate: '',
  },
  error: [], // Changed to array to match pattern (e.g., resourceStatusList)
};

const HolidayPlannerSlice = createSlice({
  name: "holidayPlanner",
  initialState,
  reducers: {
    setHolidayEvents: (state, action) => ({
      ...state,
      holidayEvents: action.payload,
    }),
    setLanguages: (state, action) => ({
      ...state,
      languages: action.payload,
    }),
    setLinguists: (state, action) => ({
      ...state,
      linguists: action.payload,
    }),
    setFilters: (state, action) => ({
      ...state,
      filters: { ...state.filters, ...action.payload },
    }),
    setError: (state, action) => ({
      ...state,
      error: action.payload,
    }),
  },
});

export const {
  setHolidayEvents,
  setLanguages,
  setLinguists,
  setFilters,
  setError,
} = HolidayPlannerSlice.actions;

export default HolidayPlannerSlice.reducer;